export * from './product-description';
export * from './room-types';
export * from './local-area';
export * from './multicentres';
export * from './reviews';
export * from './tour-map';
